import { NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  NgZone,
  OnInit,
  Output,
  QueryList,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SummitDisposing } from '@summit/models';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Tabs, TabsModule } from 'primeng/tabs';
import { Observable, takeUntil } from 'rxjs';
import { SUiTabComponent } from '../s-ui-tab/s-ui-tab.component';
@Component({
  selector: 's-ui-tab-view',
  templateUrl: './s-ui-tab-view.component.html',
  styleUrls: ['./s-ui-tab-view.component.scss'],
  standalone: true,
  imports: [TabsModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiTabViewComponent extends SummitDisposing implements OnInit, AfterViewInit {
  @Input() scrollable: boolean;
  @Input() trackInUrl: boolean;
  @Input() refreshHeaders$: Observable<boolean>;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange: EventEmitter<string> = new EventEmitter();
  @ContentChildren(SUiTabComponent) tabPanels: QueryList<SUiTabComponent>;
  @ViewChild(Tabs) primeTabs: Tabs;
  tabs: SUiTabComponent[] = [];
  @Input() startKey: string;
  noInset: boolean;
  currentTab: string;
  inDialog = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private elRef: ElementRef
  ) {
    super();
    try {
      const dialogRef = inject(DynamicDialogRef);
      if (dialogRef) {
        this.inDialog = true;
        //console.log('In dialog');
      }
    } catch (e) {
      //console.log('Not in dialog');
    }
  }

  ngOnInit() {
    if (this.inDialog) this.trackInUrl = false;
    this.refreshHeaders$?.pipe(takeUntil(this.disposing$)).subscribe((changed) => {
      this.cd.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    this.tabPanels.forEach((panel, index) => {
      panel.setIndex(index);
      this.tabs.push(panel);
    });
    const startIndex = this.tabs.findIndex((tab) => tab.disabled !== true);
    this.startKey = this.tabs[startIndex].key;
    this.noInset = this.tabs[startIndex].noInset;
    if (this.trackInUrl) {
      //set starting tab
      this.startKey = this.activeRoute.snapshot.queryParamMap.get('tab') ?? this.startKey;
      if (this.startKey) {
        const tabIndex = this.tabs.findIndex((tab) => tab.header == this.startKey);
        if (tabIndex === -1) {
          this.startKey = this.tabs[startIndex].key;
        }
      } else {
        this.startKey ??= this.tabs[startIndex].key;
      }
    } else {
      this.startKey ??= this.tabs[startIndex].key;
    }
    this.currentTab = this.startKey;
    this.noInset = !!this.tabs.find((tab) => tab.key === this.startKey)?.noInset;
    this.cd.detectChanges();
  }

  async lclChange($event: string | number) {
    this.currentTab = $event.toString();
    const selTab = this.tabs.find((tab) => tab.key === this.currentTab);
    if (!selTab) {
      return;
    }
    if (selTab.lazyTemplate) selTab.lazyAndRendered = true;
    this.noInset = selTab.noInset;
    if (this.trackInUrl) {
      //console.log(`currentTab : ${currentTab}`);
      this.ngZone.run(() => {
        this.router.navigate([], {
          relativeTo: this.activeRoute,
          queryParams: { tab: this.currentTab },
          queryParamsHandling: 'merge',
          preserveFragment: true,
          skipLocationChange: false,
          replaceUrl: true
        });
      });
    }
    this.onChange.emit($event.toString());
  }
}
